import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LightPostComponent } from './light-post/light-post.component';
import { PostComponent } from './post/post.component';
import { CommentComponent } from './comment/comment.component';
import { SharedModule } from '../../shared/shared.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ConnectionUserComponent } from './connection-user/connection-user.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { WeatherComponent } from './weather/weather.component';
import { SuggestedUsersComponent } from './suggested-users/suggested-users.component';
import { ProfileCardComponent } from '../user-connection/profile-card/profile-card.component';
import { UserCardComponent } from './user-card/user-card.component';
import { EchoDialogComponent } from './echo-dialog/echo-dialog.component';
import { QuillModule } from 'ngx-quill';
import { MarkdownModule } from 'ngx-markdown';
import { TrendsComponent } from './trends/trends.component';
import { TagCloudModule } from 'angular-tag-cloud-module';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation.directive';
import { CharacterCountPipe } from './pipes/character-count.pipe';
import { PollCalculatePercentagePipe } from './pipes/poll-calculate-percentage.pipe';
import { PollExpiredPipe } from './pipes/poll-expired.pipe';
import { PollCountDownPipe } from './pipes/poll-count-down.pipe';
import { PostTimePipe } from './pipes/post-time.pipe';
import { PostService } from './services/post.service';
import { SocialUserService } from './services/social-user.service';
import { UploadService } from './services/upload.service';
import { TimelineSubscription } from '../../shared/data/gql/subscription/timeline.subscription';
import { ConnectUsersService } from './services/connect-users.service';
import { UserPostService } from './services/user-post.service';
import { NgxLinkPreviewModule } from 'ngx-link-preview';
import { UserNotificationService } from './services/user-notification.service';
import {
  ConvertLinksDirective,
  RouterLinkComponent
} from './directives/convert-links.directive';
import { SharedPostListComponent } from './shared-post-list/shared-post-list.component';
import { MentionComponent } from './mention/mention.component';
import { MatPostInputComponent } from './mat-post-input/mat-post-input.component';
import { MatArticleInputComponent } from './mat-article-input/mat-article-input.component';
import { RepostedPostComponent } from './reposted-post/reposted-post.component';
import { ReadArticleComponent } from './read-article/read-article.component';
import { SearchService } from './services/search.service';
import { NormalToolbarComponent } from './normal-toolbar/normal-toolbar.component';
import { DirectMessageService } from './services/direct-message.service';
import { MetaDataService } from './services/meta-data.service';
import { PreviewUrlComponent } from './preview-url/preview-url.component';
import { GroupService } from './services/group.service';
import { CreatePostComponent } from './create-post/create-post.component';
import { SocialPostContentComponent } from './social-post-content/social-post-content.component';
import { UserConnectionParentComponent } from './user-connection-parent/user-connection-parent.component';
import { SearchInputService } from './services/search-input.service';
import { MiniHeaderComponent } from './mini-header/mini-header.component';
import { ReplyCommentSectionComponent } from './reply-comment-section/reply-comment-section.component';
import { ReplyCommentComponent } from './reply-comment/reply-comment.component';
import { ReportDialogComponent } from './report-dialog/report-dialog.component';
import { ImageLoaderModule } from '../../image-loader/image-loader.module';
import { GiphyComponent } from './giphy/giphy.component';
import { AuthenticateBottomSheetComponent } from './authenticate-bottom-sheet/authenticate-bottom-sheet.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { FileUploadModule } from 'ng2-file-upload';
import { ClipboardModule } from 'ngx-clipboard';
@NgModule({
  declarations: [
    CharacterCountPipe,
    PollCountDownPipe,
    PollExpiredPipe,
    PollCalculatePercentagePipe,
    LightPostComponent,
    PostComponent,
    CommentComponent,
    ConnectionUserComponent,
    SidebarComponent,
    SidenavComponent,
    WeatherComponent,
    SuggestedUsersComponent,
    ProfileCardComponent,
    PostTimePipe,
    UserCardComponent,
    EchoDialogComponent,
    TrendsComponent,
    ConfirmationDialogComponent,
    ClickStopPropagationDirective,
    RouterLinkComponent,
    ConvertLinksDirective,
    SharedPostListComponent,
    MentionComponent,
    MatPostInputComponent,
    MatArticleInputComponent,
    RepostedPostComponent,
    ReadArticleComponent,
    NormalToolbarComponent,
    PreviewUrlComponent,
    CreatePostComponent,
    SocialPostContentComponent,
    UserConnectionParentComponent,
    MiniHeaderComponent,
    ReplyCommentSectionComponent,
    ReplyCommentComponent,
    ReportDialogComponent,
    GiphyComponent,
    AuthenticateBottomSheetComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ScrollingModule,
    QuillModule,
    MarkdownModule.forChild(),
    ImageLoaderModule.forChild(),
    TagCloudModule,
    MatDialogModule,
    NgxLinkPreviewModule,
    MatBottomSheetModule,
    FileUploadModule,
    ClipboardModule
  ],
  exports: [
    CharacterCountPipe,
    PollCountDownPipe,
    PollExpiredPipe,
    PollCalculatePercentagePipe,
    LightPostComponent,
    PostComponent,
    CommentComponent,
    ConnectionUserComponent,
    SidebarComponent,
    SidenavComponent,
    WeatherComponent,
    SuggestedUsersComponent,
    ProfileCardComponent,
    PostTimePipe,
    ConfirmationDialogComponent,
    ClickStopPropagationDirective,
    RouterLinkComponent,
    ConvertLinksDirective,
    SharedPostListComponent,
    MentionComponent,
    MatPostInputComponent,
    MatArticleInputComponent,
    RepostedPostComponent,
    ReadArticleComponent,
    NormalToolbarComponent,
    PreviewUrlComponent,
    CreatePostComponent,
    SocialPostContentComponent,
    UserConnectionParentComponent,
    MiniHeaderComponent,
    ReplyCommentSectionComponent,
    ReplyCommentComponent,
    ReportDialogComponent,
    TrendsComponent,
    GiphyComponent,
    AuthenticateBottomSheetComponent,
    MatBottomSheetModule
  ],
  providers: [
    PostService,
    TimelineSubscription,
    SocialUserService,
    UploadService,
    ConnectUsersService,
    UserPostService,
    UserNotificationService,
    SearchService,
    DirectMessageService,
    MetaDataService,
    GroupService,
    SearchInputService
  ],

  entryComponents: [
    EchoDialogComponent,
    ConfirmationDialogComponent,
    ReportDialogComponent,
    AuthenticateBottomSheetComponent
  ]
})
export class SharedHomeModule {}
